<template>
  <div @click="stopTimer" v-if="showBlock" class="block">быстро нажми меня</div>
</template>

<script>
export default {
  props: ["delay"],
  data() {
    return {
      showBlock: false,
      timer: null,
      timerResult: 0,
    };
  },
  mounted() {
    setTimeout(() => {
      this.showBlock = true;
      this.startTimer();
    }, this.delay);
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.timerResult += 10;
      }, 10);
    },
    stopTimer() {
       clearInterval(this.timer);
       this.$emit('end',this.timerResult)
    },
  },
};
</script>

<style>
.block {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 400px;
  padding: 100px 0;
  margin: 20px auto;
  margin-top: 60px;
  background: rgb(245, 122, 149);
  border: 2px solid rgb(255, 0, 0);
  border-radius: 30px;
}
</style>